// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__ufDTq","messages":"Chat_messages__1Og7z","dateDivider":"Chat_dateDivider__1BIhs"};